<template>
    <b-card-body v-bind="$props">
        <slot />
    </b-card-body>
</template>

<script>
import { BCardBody } from 'bootstrap-vue'

export default {
    components: { BCardBody },
}
</script>